module.exports = __webpack_public_path__ + "img/01_tu.54363297.png";